<template>
  <div class="header">
    <img class="d-none d-sm-block" src="../assets/header.png" />
    <img class="d-block d-sm-none" src="../assets/header_mobile.png" />
    <div class="title-wrapper">
      <h1>Configurador de <strong class="d-block">Contratos</strong></h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["titulo"]
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  color: #ffffff;
  display: flex;
  align-items: center;
  overflow: hidden;
  & > img {
    width: 100%;
    height: 44.3em;
    object-fit: cover;
    @media (max-width: 669px) {
      height: 54.3em;
    }
  }

  h1 {
    margin-bottom: 1em;
    font-weight: 400;
    color: white !important;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
  }

  h2 {
    font-weight: 300;
  }

  h3 {
    font-size: 2.8em;
    font-weight: bold;
    letter-spacing: 0.02em;
    @media (max-width: 767px) {
      font-size: 2em;
    }
  }

  .title-wrapper {
    position: absolute;
    top: 19%;
    left: 5.7%;
    width: 100%;
    padding-top: 3em;
    padding-left: 3rem;
    @media (max-width: 669px) {
      padding-top: 0;
      padding-left: 0;
      top: auto;
      bottom: 28%;
    }

    h1 {
      line-height: 1.1em;
      font-size: 4.7em;
      letter-spacing: 0.001em;
      font-family: "vw-head", Arial, Helvetica, sans-serif;
      font-weight: 300;
      color: #ffffff;
      strong {
        font-size: 1.1em;
        font-weight: 700;
        letter-spacing: -0.03em;
      }
      @media (max-width: 767px) {
        font-size: 3.9em;
        line-height: 1.2em;
        padding-top: 0;
        margin-top: 0;
      }
    }
    h2 {
      @media (max-width: 767px) {
        font-size: 2em;
        margin-bottom: 1em;
      }
    }
  }
}
</style>
